/* tslint:disable */
import {
  Emoji,
  Game
} from '../index';

declare var Object: any;
export interface GameEmojiInterface {
  "emojiId"?: any;
  "gameId"?: any;
  "position": number;
  "popup"?: any;
  "sfx"?: string;
  "id"?: any;
  emoji?: Emoji;
  game?: Game;
}

export class GameEmoji implements GameEmojiInterface {
  "emojiId": any;
  "gameId": any;
  "position": number;
  "popup": any;
  "sfx": string;
  "id": any;
  emoji: Emoji;
  game: Game;
  constructor(data?: GameEmojiInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `GameEmoji`.
   */
  public static getModelName() {
    return "GameEmoji";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of GameEmoji for dynamic purposes.
  **/
  public static factory(data: GameEmojiInterface): GameEmoji{
    return new GameEmoji(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'GameEmoji',
      plural: 'GameEmojis',
      path: 'GameEmojis',
      idName: 'id',
      properties: {
        "emojiId": {
          name: 'emojiId',
          type: 'any'
        },
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "position": {
          name: 'position',
          type: 'number',
          default: 1
        },
        "popup": {
          name: 'popup',
          type: 'any'
        },
        "sfx": {
          name: 'sfx',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        emoji: {
          name: 'emoji',
          type: 'Emoji',
          model: 'Emoji',
          relationType: 'belongsTo',
                  keyFrom: 'emojiId',
          keyTo: 'id'
        },
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
      }
    }
  }
}
